import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Index from './pages/Index';
import Demo from './pages/Demo';
import UseCases from './pages/UseCases';
import NotFound from './pages/NotFound';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Index data-id="element-3" />} data-id="element-2" />
        <Route path="/demo" element={<Demo data-id="element-5" />} data-id="element-4" />
        <Route path="/use-cases" element={<UseCases data-id="element-7" />} data-id="element-6" />
        <Route path="*" element={<NotFound data-id="element-9" />} data-id="element-8" />
      </Routes>
    </BrowserRouter>;
}